<template>
  <v-dialog width="500" v-model="showDepartmentForm">
    <v-card>
      <v-card-title class="secondary white--text">
        <span> {{ editMode ? "Update" : "Add" }} Department </span>

        <v-spacer></v-spacer>

        <v-btn icon @click="resetForm(), (showDepartmentForm = false)">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-2">
        <v-form
          ref="departmentForm"
          v-if="showDepartmentForm"
          v-model="isValid"
        >
          <v-row class="my-0">
            <v-col cols="12" class="Form-Columns">
              <InputField
                type="text"
                label="Department Name *"
                required
                :rules="[
                  (val) => !!val || 'Department Name is Required!',
                  (val) =>
                    !$globals.numbersOnlyRegExp.test(val) ||
                    'Invalid Department Name!',
                ]"
                hide-details="auto"
                v-model="departmentDetails.department_name"
                :error-messages="formErrors.department_name"
                @input="delete formErrors.department_name"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          depressed
          :disabled="!isValid"
          @click="submitForm"
        >
          Submit
        </v-btn>

        <v-btn
          class="ml-3"
          color="secondary"
          v-if="!editMode"
          depressed
          @click="resetForm"
        >
          Reset
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import SelectField from "@/components/FormBaseComponents/SelectField.vue";

export default {
  components: {
    InputField,
    SelectField,
    MultiSelect,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    editDepartmentID: {
      type: [Number, null],
      default: null,
    },
  },
  watch: {
    value(val) {
      if (val) {
        if (this.editMode) {
          this.getDepartmentObject(this.editDepartmentID);
        }
      } else {
        this.resetForm();
      }
    },
  },
  computed: {
    showDepartmentForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      formErrors: {},
      isValid: true,
      isTextInput: false,

      departmentDetails: {},
    };
  },
  methods: {
    submitForm() {
      this.$bus.$emit("showLoader", true);
      if (!this.editMode) {
        this.departmentDetails = {
          ...this.departmentDetails,
        };
        this.$api.department
          .addDepartment(this.departmentDetails)
          .then((res) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Department added successfully!",
              color: "success",
            });
            this.resetForm();
            this.showDepartmentForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Couldn't add department!",
              color: "error",
            });
            this.formErrors = err.data;
          });
      } else {
        this.$api.department
          .updateDepartment({
            id: this.departmentDetails.id,
            data: this.departmentDetails,
          })
          .then((res) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Department updated successfully!",
              color: "success",
            });
            this.resetForm();
            this.showDepartmentForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Couldn't update department!",
              color: "error",
            });
            this.formErrors = err.data;
          });
      }
    },

    resetForm() {
      if (this.$refs.departmentForm) {
        this.$refs.departmentForm.reset();
      }
      this.departmentDetails = {};
    },

    getDepartmentObject(id) {
      this.$bus.$emit("showLoader", true);
      this.$api.department
        .getDepartmentObject(id)
        .then((res) => {
          this.$bus.$emit("showLoader", false);
          this.departmentDetails = res.data;
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
  },
};
</script>
